import { Layout } from 'antd';
import { Outlet } from 'react-router';

/**
 * Components
 */
import Sider from './sider';

/**
 * Types
 */
import type { LayoutProps, SiderProps } from 'antd';

const Page: React.FC = () => {
    /**
     * ChildrenProps
     */
    const layoutProps: LayoutProps = {
        style: {
            height: '100vh',
        },
    };

    const siderProps: SiderProps = {
        collapsed: true,
        collapsedWidth: 56,
        theme: 'light',
        style: {
            padding: '24px 0',
        },
    };

    return (
        <Layout {...layoutProps}>
            <Layout.Sider {...siderProps}>
                <Sider />
            </Layout.Sider>

            <Layout.Content>
                <Outlet />
            </Layout.Content>
        </Layout>
    );
};

export default Page;
